
const chartColors = ['#09b3af', '#f0ad4e', '#d9544f']

export default chartColors



// WEBPACK FOOTER //
// ./src/libs/chartColors.definition.js